<app-social-band></app-social-band>
<footer>
  <div class="container footer-nav">
    <div class="row">
      <div class="col-xs-6 col-md-12 col-lg-4 footer-section footer-lost-pet">
        <h2>Lost a pet?</h2>
        <div
          *ngIf="
            !(
              userService.isUserStoredInServicePremium() ||
              userService.isUserStoredInServiceBasicPlus()
            )
          "
          class="lost-pet_call"
        >
          <p class="lost-pet_call_text">Call us on</p>
          <p class="lost-pet_call_telephone">{{ companyPhoneNumber }}</p>
        </div>
        <div
          *ngIf="
            userService.isUserStoredInServicePremium() ||
            userService.isUserStoredInServiceBasicPlus()
          "
          class="lost-pet_call"
        >
          <p class="lost-pet_call_text">
            As a member, you have access to our 24/7 helpline, which you can call on
          </p>
          <p class="lost-pet_call_telephone">{{ companyMemberPhoneNumber }}</p>
        </div>
        <div class="trustpilot">
          <app-trustbox-footer-widget></app-trustbox-footer-widget>
        </div>
      </div>

      <div class="col-xs-6 col-md-6 col-lg-4 footer-section footer-contact-us">
        <h2>Contact us</h2>
        <div [innerHTML]="footerAddressHtml"></div>
      </div>

      <div *ngIf="links" class="col-xs-6 col-md-6 col-lg-4 footer-section footer-links">
        <h2>Links</h2>
        <ul>
          <li *ngFor="let link of links">
            <a href="{{ baseUrl + link.route }}">
              {{ link.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container subfooter">
    <span>
      {{ copyrightText }}
    </span>
  </div>
</footer>
